/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { GameStatusManager } from '../services/manager';
import { addGuest, addGuestNotification, cancelSubcription, getGameById, joinGameAdd } from '../services/game';
import { gameActions } from './definition';
import { IJoinGame } from '../interfaces/game';

function gameIsLoading() {
    return {
        type: gameActions.GAME_IS_LOADING,
    };
}

const gameReset = () => {
    return {
        type: gameActions.GAME_RESET,
    };
};

function gameError(e: string) {
    return {
        type: gameActions.GAME_ERROR,
        error: e,
        data: e,
    };
}

function gameSet(games: any) {
    return {
        type: gameActions.GAME,
        data: games,
    };
}

/**
 * Reducer to rest a games
 * @param values Data to reset games
 */
export const resetStateGame = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameReset());
    };
};

/**
 * Reducer to rest a games
 * @param values Data to reset games
 */
export const resetGameReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameReset());
    };
};

/**
 * Reducer to reset Games
 * @param values Values to reset games
 */
export const resetGame = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameReset());
    };
};

/**
 * Reducer to get a game by id
 * @param id Id of game to find
 */
export const fetchGameById = (id: string, statusUser: boolean) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(gameIsLoading());
        try {
            const response = await getGameById(id, statusUser);
            if (response?.statusCode === GameStatusManager.GAME_BY_ID && response.data) {
                dispatch(gameSet(response));
            } else {
                dispatch(gameError('Could not get game'));
            }
        } catch (error: any) {
            dispatch(gameError('No se pudo obtener el game'));
        }
    };
};

/**
 * Reducer  join game
 * @param values Data to create a join game
 */
export const joinGame = (values: IJoinGame) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(gameIsLoading());
            const game = await joinGameAdd(values);
            if (game?.statusCode === 'GAME_PLAYER_JOINED') {
                dispatch(gameSet(game));
                await addGuestNotification(values);
            } else {
                dispatch(gameError('No se pudo crear el partido'));
            }
        } catch (error: any) {
            if (error.response && error.response.data) {
                if (error.response.data?.statusCode === 'PLAYER_ALREADY_IN_THIS_GAME') {
                    dispatch(gameError('Ya te uniste a este partido'));
                } else if (error.response.data?.statusCode === 'GAME_JOIN_TEAM_ERROR') {
                    dispatch(gameError('error no se pudo unir al partido'));
                } else {
                    dispatch(gameError('No se pudo unir al partido'));
                }

                return;
            } else {
                dispatch(gameError('No se pudo unir al partido'));
                return;
            }
        }
    };
};

/**
 * Reducer  add guest game
 * @param values Data to create a add guest game
 */
export const addGuestGame = (values: IJoinGame) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(gameIsLoading());
            const game = await addGuest(values);
            if (game?.statusCode === 'GAME_ADD_GUESTS_SUCCESSFULLY') {
                dispatch(gameSet(game));
                await addGuestNotification(values);
            } else {
                dispatch(gameError('No se pudo agregar mas amigos al partido'));
            }
        } catch (error: any) {
            if (error.response && error.response.data) {
                if (error.response.data?.statusCode === 'PLAYER_ALREADY_IN_THIS_GAME') {
                    dispatch(gameError('Ya agregastes mas amigos a este partido'));
                } else {
                    dispatch(gameError('No se pudo agregar mas amigos al partido'));
                }

                return;
            } else {
                dispatch(gameError('No se pudo agregar mas amigos al partido'));
                return;
            }
        }
    };
};

/**
 * Reducer  add guest game
 * @param values Data to create a add guest game
 */
export const gameCancelSubcription = (values: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(gameIsLoading());
            const game = await cancelSubcription(values);
            if (game?.statusCode === 'GAME_CANCEL_SUBSCRIPTION_SUCCESSFULLY') {
                dispatch(gameSet(game));
            } else {
                dispatch(gameError('No se pudo cancelar el partido'));
            }
        } catch (error: any) {
            if (error.response && error.response.data) {
                if (error.response.data?.statusCode === 'GAME_PLAYER_NOT_FOUND') {
                    dispatch(gameError('Juego no existe'));
                } else {
                    dispatch(gameError('No se pudo cancelar el partido'));
                }

                return;
            } else {
                dispatch(gameError('No se pudo cancelar al partido'));
                return;
            }
        }
    };
};
